import { type HomePageType } from '../apis/home-api';

export interface HomeService {
    getHomePageType(): Promise<{homepage_type: HomePageType}>;
    changeHomePage(home_page_type: HomePageType): Promise<boolean>;
}

export const HomeService = Symbol('HomeService');
